const base = 'DefaultTexts';

const DefaultTextKeys = {
  listHubText: `${base}/HUB_TEXTS`,
  listClusterText: `${base}/CLUSTER_TEXTS`,
};

export default DefaultTextKeys;
